// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__3bbRY","content":"ManualTimeModal_content__7qQcN"};